export const bottomOffsetClass = (isChartScrollable: any) => {
  return isChartScrollable ? 'bottom-0' : 'bottom-[14px]';
};
